import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { removeNotification } from '../../services/redux/slices/toastNotificationSlice';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Typography, IconButton ,SnackbarContent} from '@mui/material';
import { styled } from "@mui/material/styles";
import InfoIcon from '@mui/icons-material/Info';

export default function Toastify() {
    const notifications = useSelector((state) => state.toastNotification);
    const dispatch = useDispatch();

    const handleClose = (id) => {
        dispatch(removeNotification(id));
    };

    const handleIcons = (type) => {

        const width = "24px";

        return (
            <>
                {type === 'success' && <img src={require("../../assets/icons/notification/success.png")} alt="" style={{ width: width }} />}
                {type === 'info' && <img src={require("../../assets/icons/notification/info.png")} alt="" style={{ width: width }} />}
                {type === 'error' && <img src={require("../../assets/icons/notification/error.png")} alt="" style={{ width: width }} />}
                {type === 'warning' && <img src={require("../../assets/icons/notification/waring.png")} alt="" style={{ width: width }} />}
            </>
        )
    }

    return (
        <>
            {notifications?.map((notification) => (
                <Snackbar
                    ContentProps={{
                        sx: {
                        background: "white",
                        padding: "1px 6px 11px 3px",
                        borderRadius:"6px",
                            height: "100%",
                            top:"50%",

                        }
                    }}
                    key={notification.id}
                    open
                    autoHideDuration={notification.autoHideDuration || 30000000}
                    onClose={() => handleClose(notification.id)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center'}} // Position top-right
                    TransitionProps={{ onExited: () => handleClose(notification.id) }}
                    message={
                        <Box>
                            <Box display="flex" alignItems="center" sx={{ padding: "15px",paddingLeft: "20px",
                                paddingBottom: "20px", color: "black", width: '100%' }}>
                                {handleIcons(notification.type)}&nbsp;&nbsp;&nbsp; {/* Assuming handleIcons returns the appropriate icon */}
                                <Typography variant="h6" style={{ marginRight: 8 }}>
                                    {notification.title}
                                </Typography>
                                
                                {/* Close Icon right-aligned */}
                                <Box flexGrow={1} /> {/* This acts as a spacer, pushing the CloseIcon to the right */}
                                <IconButton size="small" color="inherit" onClick={handleClose}>
                                <CloseIcon onClick={() => handleClose(notification.id)} sx={{width:"20px"}}/>
                                </IconButton>
                            </Box>
                            
                            <Typography variant="body2" style={{ marginTop: "-12px",marginLeft:"56px", color: "black",width: "333px",textWrap: "wrap", }}>
                                {notification.message}
                            </Typography>
                        </Box>

                    }
                    // action={
                    //     <React.Fragment>
                    //         <IconButton
                    //             aria-label="close"
                    //             color="inherit"
                    //             sx={{ p: 0.5 }}
                    //             onClick={() => handleClose(notification.id)}
                    //         >
                    //             <CloseIcon />
                    //         </IconButton>
                    //     </React.Fragment>
                    // }
                />
            ))}
        </>
    );
}